import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { theme } from '../common/theme';
import CourtOwnerDashboard from './CourtOwnerDashboard';

const CourtDashboardPage = () => {
  return (
    <Box 
      sx={{ 
        minHeight: '100vh',
        backgroundColor: theme.colors.primaryBackground,
        background: `linear-gradient(135deg, ${theme.colors.primaryBackground} 0%, ${theme.colors.secondaryBackground} 100%)`
      }}
    >
      {/* Standalone Header */}
      <Box 
        sx={{ 
          backgroundColor: theme.colors.secondaryBackground,
          boxShadow: theme.shadows.medium,
          borderBottom: `1px solid ${theme.colors.border}`,
          position: 'sticky',
          top: 0,
          zIndex: 1000
        }}
      >
        <Container maxWidth="xl" sx={{ py: theme.spacing.lg }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing.md }}>
            <Box 
              sx={{ 
                width: 48, 
                height: 48, 
                backgroundColor: theme.colors.accentBlue,
                borderRadius: theme.borderRadius.md,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Typography 
                sx={{ 
                  color: theme.colors.white,
                  fontSize: '1.5rem',
                  fontWeight: 'bold'
                }}
              >
                🏟️
              </Typography>
            </Box>
            <Box>
              <Typography 
                variant="h4" 
                sx={{ 
                  fontWeight: 'bold',
                  background: `linear-gradient(135deg, ${theme.colors.accentBlue} 0%, ${theme.colors.accentBlue} 100%)`,
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  textShadow: theme.shadows.small,
                  fontFamily: theme.fonts.primary
                }}
              >
                Court Management
              </Typography>
              <Typography 
                variant="subtitle1" 
                sx={{ 
                  color: theme.colors.textSecondary,
                  mt: theme.spacing.xs,
                  fontFamily: theme.fonts.secondary
                }}
              >
                Manage your courts, cameras, and streaming sessions
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>
      
      {/* Dashboard Content */}
      <CourtOwnerDashboard />
    </Box>
  );
};

export default CourtDashboardPage;
